<template>
    <DashView>
        <div class="container-fluid pt-4 px-4">
            <div class="row g-4">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <h3><a href="#" data-bs-toggle="modal" data-bs-target="#myModalAddAssurance"><i class="fa fa-plus-square"></i></a>&nbsp;Assurance <span class="badge bgbadge">{{assurances.length}}</span> </h3>
                            <div class="table-responsive">
                                <template v-if="assurances.length>0">  
                                    <table class="table table-striped table-bordered display text-center">
                                        <thead>
                                            <tr>
                                                <th>Nom</th>
                                                <th>Adresse</th>
                                                <th>Téléphone</th>
                                                <th>Mail</th>
                                                <th>Site</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                                <tr v-for="assurance in assurances" :key="assurance.code_assurance">
                                                    <td>{{assurance.assurance}}</td>
                                                    <td>{{assurance.adresse}}</td>
                                                    <td>{{assurance.telephone}}</td>
                                                    <td>{{assurance.mail}}</td>
                                                    <td>{{assurance.site}}</td>
                                                    <td>
                                                        <a href="#" class="text-inverse mx-3" @click="editAssurance(assurance)" title="Edit" data-bs-toggle="modal" data-bs-target="#myModalUpdateService"><i class="fa fa-edit"></i></a>
                                                    </td>                                                
                                                </tr>                                
                                        </tbody>
                                    </table>
                                </template>
                                <template v-else>
                                    <div class="modal-preloader">
                                        <div class="spinner"></div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </DashView>
     <!--Begin All Modal -->
          <!--Begin Add Assurance -->
          <div class="modal" id="myModalAddAssurance">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header">
                    <h4 class="modal-title">Enrégister Assurance</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                        <div class="row" v-if="validationErrors.length>0">
                            <div class="offset-2 col-md-8 col-sm-12 alert alert-danger alert-md text-danger mx-auto">
                                <ul v-if="validationErrors.length>0" class="list-unstyled text-center mx-auto">
                                    <li v-for="(error,key) in validationErrors" :key="key" class="p-2"><div class="">{{error}}</div></li>
                                </ul>
                            </div>
                        </div>
                        <p v-if="success_msg" class="text-white alert text-center" style="background: #00C853;">{{ success_msg }}</p>
                        <div class=" mx-auto">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="usname">Assurance</label>
                                            <input type="text" v-model="form.nom" title="Ajouter Nom" placeholder="Nom" required id="usname" class="form-control" autofocus="true">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="usname">Adresse</label>
                                            <input type="text" v-model="form.adresse" title="Ajouter Adresse" placeholder="Adresse" required id="usadresse" class="form-control" autofocus="true">
                                        </div>
                                    </div>
                                    
                                </div> 
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="usname">Téléphone</label>
                                            <input type="text" v-model="form.telephone" title="Ajouter Phone" placeholder="Phone" required id="usphone" class="form-control" autofocus="true">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="usname">Email</label>
                                            <input type="text" v-model="form.email" title="Ajouter Email" placeholder="Email" required id="usmail" class="form-control" autofocus="true">
                                        </div>
                                    </div>
                                    
                                </div> 
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="usname">Site web</label>
                                            <input type="text" v-model="form.site" title="Ajouter Site Web" placeholder="Site web" required id="usphone" class="form-control" autofocus="true">
                                        </div>
                                    </div>
                                    <!-- <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="usname">Email</label>
                                            <input type="text" v-model="form.email" title="Ajouter Email" placeholder="Email" required id="usmail" class="form-control" autofocus="true">
                                        </div>
                                    </div> -->
                                    
                                </div>                                
                                <div class="row">
                                    <div class="pt-2">
                                        <button type="submit" class="btn btn-block btn-lg col-12" style="background:#00C853; color: #fff;" @click="registerAssurance">Ajouter</button>
                                    </div>
                                </div>	
                        </div>
                </div>

                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" id="closeModalAddAssurance" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                </div>

                </div>
            </div>
         </div>
          <!--End Add Assurance -->

                   <!-- The Modal Update Assurance-->
            <div class="modal" id="myModalUpdateService">
                <div class="modal-dialog">
                    <div class="modal-content">             
                        <!-- Modal Header -->
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Modifié Assurance</h5>
                            <button type="button" id="closeModifierUser" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        
                        <!-- Modal body -->
                        <div class="modal-body">
                            <p v-if="success_msg" class="text-white alert text-center" style="background: #00C853;">{{ success_msg }}</p>
                            <template v-if="form_update?.assurance">
                                <div class="col-lg-12">
                                    <div class="card mb-4">
                                        <div class="card-body">
                                            <!-- <form @submit.prevent="UpdateService"> -->
                                                <div class="row" v-if="validationErrors.length>0">
                                                    <div class="offset-2 col-md-8 col-sm-12 alert alert-danger alert-md text-danger mx-auto">
                                                        <ul v-if="validationErrors.length>0" class="list-unstyled text-center mx-auto">
                                                            <li v-for="(error,key) in validationErrors" :key="key" class="p-2"><div class="">{{error}}</div></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-4">
                                                        <p class="mb-0">Assurance</p>
                                                    </div>
                                                    <div class="col-sm-8">
                                                        <input type="text" v-model="form_update.assurance" class="form-control">
                                                    </div>
                                                </div>
                                                <hr>
                                                <div class="row">
                                                    <div class="col-sm-4">
                                                        <p class="mb-0">Email</p>
                                                    </div>
                                                    <div class="col-sm-8">
                                                        <input type="text" v-model="form_update.mail" class="form-control">
                                                    </div>
                                                </div>
                                                <hr>
                                                <div class="row">
                                                    <div class="col-sm-4">
                                                        <p class="mb-0">Téléphone</p>
                                                    </div>
                                                    <div class="col-sm-8">
                                                        <input type="text" v-model="form_update.telephone" class="form-control">
                                                    </div>
                                                </div>
                                                <hr>
                                                <div class="row">
                                                    <div class="col-sm-4">
                                                        <p class="mb-0">Site</p>
                                                    </div>
                                                    <div class="col-sm-8">
                                                        <input type="text" v-model="form_update.site" class="form-control">
                                                    </div>
                                                </div>
                                                <hr>
                                                <div class="row">
                                                    <div class="col-sm-4">
                                                        <p class="mb-0">Adresse</p>
                                                    </div>
                                                    <div class="col-sm-8">
                                                        <textarea v-model="form_update.adresse" class="form-control"></textarea>
                                                    </div>
                                                </div>
                                            <!-- </form>    -->
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <!-- <p class="text-center">Loading...</p> -->
                                <div class="modal-preloader">
                                    <div class="spinner"></div>
                                </div>
                            </template>
                        </div>
                        
                        <!-- Modal footer -->
                        <div class="modal-footer d-flex justify-content-between">
                            <button type="button" :disabled="form_update.assurance =='' || form_update.mail=='' || form_update.telephone=='' || form_update.id==''" class="btn float-left" style="background-color: #00C853; color: #fff;" @click="UpdateAssurance">Enrégistrer</button>
                            <button type="button" id="closeModalUpdated" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                        </div>
                        
                    </div>
                </div>
            </div>
        <!-- End Modal Update Assurance -->

        <!-- End All Modal -->
</template>
<script>
import DashView from "@/components/DashView.vue"
import axios from 'axios'
  import $ from 'jquery';
  const base_url=process.env.VUE_APP_API_URL;
export default {
    name:"AssuranceAll",
    components:{
        DashView
    },
    data(){
      return{
          assurances:[],
          info_assurance:[],
          success_msg:'',
          editeurAssurance:[],
          validationErrors:[],
          accessToken:JSON.parse(localStorage.getItem('user_zgh')).token ?? '',
          form:{
            nom:'',
            adresse:'',
            telephone:'',
            email:'',
            site:''
          },
          form_update:{
            id:'',
            assurance:'',
            mail:'',
            adresse:'',
            telephone:'',
            site:'',
          }
      }
    },
    created(){
        // (JSON.parse(localStorage.getItem('user_zgc')).code_role)>3 ? this.$router.push('all-vente'):true;
        // const accessToken = JSON.parse(localStorage.getItem('user_zgc')).token ?? '';
        axios.get(`${base_url}/all_assurance`,{
                    headers:{
                            Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
              .then((response)=>{
                  console.log(response.data);
                  if(response.data){
                      this.assurances = response.data;
                  }
                  
                  
              })
              .catch((error)=>{
                console.log(error?.response?.status);
                if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#openModalNoAccess').trigger('click');
                }
                else {
                // Gérer d'autres erreurs ici
                console.log('Une erreur est survenue!');
                console.log('Autre erreur:', error);
                }
              });
    },
    methods:{
        formatDate(dateString) {
            const date = new Date(dateString);
            const day = ('0' + date.getDate()).slice(-2);
            const month = ('0' + (date.getMonth() + 1)).slice(-2);
            const year = date.getFullYear();
            const hours = ('0' + date.getHours()).slice(-2);
            const minutes = ('0' + date.getMinutes()).slice(-2);
            const seconds = ('0' + date.getSeconds()).slice(-2);

            return `${day}-${month}-${year} à ${hours}h ${minutes}mn ${seconds}s`;
        },
        getInfoassurance(code){ 
                //   console.log(code);
                const accessToken = JSON.parse(localStorage.getItem('user_zgc')).token ?? '';
                axios.get(`${base_url}/infoassurance?code=${code}`,{
                headers:{
                    Accept:'application/json',
                    'Content-Type':'application/json;charset=UTF-8',
                    Authorization:`Bearer ${accessToken}`
                }
            })
            .then((response)=>{
                const info = response.data;
            //   console.log(info);
                this.updateModalContent(info);
            })
            .catch((error)=>{
            if(error?.response?.status === 403){
                    console.log('NO access');
                    $('#openModalNoAccess').trigger('click');
            }
            else {
            // Gérer d'autres erreurs ici
            console.log('Une erreur est survenue!');
            console.log('Autre erreur:', error);
            }
            })
        },
        updateModalContent(donnee){
            this.info_assurance=donnee;
        },
        redirectTo(path) {
            this.$router.push(path);
            setTimeout(function() {
            location.reload();
            }, 1);
        },
        registerAssurance(){
            console.log('ok');
            console.log(this.form);
            this.success_msg='';
            // return false;
            const control = !!(this.form.nom && this.form.adresse && this.form.telephone && this.form.email && this.form.site);
            console.log(control);
            if(control){
                    const $data ={
                    nom : this.form.nom,
                    adresse : this.form.adresse,
                    telephone : this.form.telephone,
                    email:this.form.email,
                    site: this.form.site
                };
                // console.log($data);
                axios.post(`${base_url}/add_assurrance`,$data,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    console.log(response.data);
                    if(response.status==201){
                        this.success_msg = `Assurance ajouté avec success!`;
                        setTimeout(function() {
                            location.reload();
                        },2000);
                    }
                    else{
                        console.log('Erreur!!!');
                    }
                })
                .catch((error)=>{
                    // console.log(error);
                    if (error?.response?.status === 401) {
                            const error_msg = error.response.data.errors;
                            console.log(error_msg);
                            this.displayValidationErrors(error.response.data.errors);                       
                    } 
                    else if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#closeModalAddAssurance').trigger('click');
                        $('#openModalNoAccess').trigger('click');
                    }
                    else {
                    // Gérer d'autres erreurs ici
                    console.log('Autre erreur:', error);
                    }
                })
            }
        
        },
        displayValidationErrors(errors) {
            this.validationErrors = [];

            // Parcourir les erreurs et les ajouter au tableau
            Object.keys(errors).forEach(field => {
                this.validationErrors.push(errors[field][0]);
            });

            // Définir un délai de 5 secondes avant de vider les erreurs
            setTimeout(() => {
                this.clearValidationErrors();
            }, 5000);

        },
        clearValidationErrors() {
            this.validationErrors = [];
        },
        editAssurance(assurance){
            this.form_update = {
                id: '',
                assurance: '',
                mail: '',
                adresse: '',
                telephone: '',
                site: ''
            };
            if(assurance){
                this.form_update.id = assurance.assurance_id;
                this.form_update.assurance = assurance.assurance;
                this.form_update.site = assurance.site;
                this.form_update.mail = assurance.mail;
                this.form_update.adresse = assurance.adresse;
                this.form_update.telephone = assurance.telephone;
            }
        },
        UpdateAssurance(){
            const $data={
                assuranceId:this.form_update.id,
                assurance:this.form_update.assurance,
                telephone:this.form_update.telephone,
                mail : this.form_update.mail,
                adresse : this.form_update.adresse,
                site:this.form_update.site
            };
            // console.log($data);
            // return false;
            
            if($data){
                axios.put(`${base_url}/update_assurance`,$data,{
                headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    // console.log(response?.data);
                    if(response?.status==200){
                        setTimeout(function() {
                            location.reload();
                        },1);
                    }                
                })
                .catch((error)=>{
                    // console.log(error);
                        if (error?.response?.status === 401) {
                            const error_msg = error.response.data.errors;
                            this.displayValidationErrors(error.response.data.errors);                       
                        } 
                        else if(error?.response?.status === 403){
                            // this.$router.push('/no-access');
                            console.log('NO access');
                            $('#closeModalUpdateService').trigger('click');
                            $('#openModalButton').trigger('click');
                        }
                        else {
                        // Gérer d'autres erreurs ici
                        console.log('Autre erreur:', error);
                        }
                });
            }
        }
    }
}
</script>
<style lang="">
    
</style>